import { useState } from 'react';

/**
 * A password box with a Show/Hide button.
 *
 * Typing a long password blind is where sign-ins fail, especially on a phone
 * keyboard that hides the last character after a moment. It is also the only
 * way an office user setting somebody else's password can check what they are
 * about to read out to them.
 *
 * It starts hidden every time and is never remembered: revealing is a
 * deliberate act by whoever is standing at the screen.
 */
export default function PasswordInput({
  id, value, onChange, autoComplete, autoFocus, placeholder, style,
}: {
  id?: string;
  value: string;
  onChange: (v: string) => void;
  autoComplete: 'current-password' | 'new-password';
  autoFocus?: boolean;
  placeholder?: string;
  style?: React.CSSProperties;
}) {
  const [shown, setShown] = useState(false);
  return (
    <div className="input-with-button" style={style}>
      <input id={id} type={shown ? 'text' : 'password'}
             autoComplete={autoComplete} autoFocus={autoFocus}
             placeholder={placeholder}
             value={value} onChange={(e) => onChange(e.target.value)} />
      {/* type=button, or pressing it submits the form instead of revealing. */}
      <button type="button" className="reveal"
              onClick={() => setShown((v) => !v)}
              aria-pressed={shown}
              aria-label={shown ? 'Hide password' : 'Show password'}
              title={shown ? 'Hide password' : 'Show password'}>
        {shown ? 'Hide' : 'Show'}
      </button>
    </div>
  );
}
